import Slider from '@/components/ui/SliderOld';

const testimonials = [
  {
    image: '/images/img_voice_sonia_1.png',
    name: 'Sonia Jairaj',
    title: 'Senior Human Resources Business Partner (Sr. HRBP)',
    quote:
      '"Being part of this team has been an incredibly fulfilling experience. Every day here is a learning opportunity. Being surrounded by passionate, curious, and driven individuals constantly pushes me to grow. The leadership is empowering, and the freedom to experiment has helped me evolve both as a professional and a person. The energy here is contagious, and that’s what makes this team truly special!"',
  },
  {
    image: '/images/img_voice_chetan_1.png',
    name: 'Chetan Sharma',
    title: 'Software Development Engineer II (SDE-2)',
    quote:
      '"I began as a Business Analyst and moved into software development with little prior experience. At SixSense, the trust from my manager and leadership helped me grow—from under-confident to leading client meetings and delivering products end-to-end. The freedom to share ideas and the support of a chill, driven team made it feel like my company from day one. I’m excited to keep growing with SixSense."',
  },
  {
    image: '/images/img_voice_dom.png',
    name: 'Dominic Teo',
    title: 'Enterprise Account Executive (AI solutions)',
    quote:
      '"The people in SixSense are determined, good at what they do, and at the same time friendly and without airs. SixSense is a fast growing and fast pace startup, I’m glad to have been here for over 5 years, and to witness the evolution of our product and business. No regrets joining SixSense and learning from all the incredible people I come into contact with daily."',
  },
  {
    image: '/images/img_voice_shreya.png',
    name: 'Shreya Mohan',
    title: 'Data Analyst',
    quote:
      '“Looking back on my five-plus years at SixSense, I feel genuinely grateful for the journey I’ve had here. I’ve had the privilege of working alongside some of the brightest, most supportive colleagues I could ask for. I’ve been trusted with real responsibilities, encouraged to experiment, and given the freedom to pursue new ideas. Proud to be part of a company that values creativity, learning, and teamwork.”',
  },
  {
    image: '/images/img_voice_eric.png',
    name: 'Eric Mao',
    title: 'AI ADC Solution Sales Executive and Head Taiwan',
    quote:
      "“SixSense is no doubt a group of young talents of AI expertise in semiconductor with passion to help empower the world's smart manufacturing. As a member in charge of the business in Taiwan for1 + year on AI ADC solution, I'm confident that we will change the landscape here and very proud to work with all at this company.“",
  },
  {
    image: '/images/img_voice_benny.png',
    name: 'Benny Zhen-Peng BIAN',
    title: 'Head of AI',
    quote:
      "“My experience at SixSense is incredibly rewarding. As part of a pioneering company in AI-driven semiconductor defect detection/classification, my AI team and I have the opportunity to contribute to cutting-edge solutions that significantly enhance manufacturing efficiency and product quality. Collaborating with global Tier-1 semiconductor leaders further enriches my expertise, allowing me to learn from their rigorous quality standards and industry best practices. It's an honor to actively shape the future of smart manufacturing.”",
  },
  {
    image: '/images/img_voice_ayaz.png',
    name: 'Ayaz Aslam',
    title: 'Senior AI Engineer',
    quote:
      '“What makes SixSense truly special is the blend of meaningful AI work and the incredible people behind it. The founders lead with clarity and humility, and the culture here is open, collaborative, and deeply empowering. As a Senior AI Engineer, I’m not just experimenting with models — I’m solving real-world problems end-to-end: understanding customer pain points, shaping the product, and building AI that actually makes a difference. It’s not just about innovation — it’s about impact.”',
  },

  {
    image: '/images/img_voice_vaishali.png',
    name: 'Vaishali Bisht',
    title: 'Lead Technical Recruiter',
    quote:
      '“When I joined SixSense three years ago, we were a small team of just 5\–6 engineers. Today, we\’ve grown into a thriving team of 35—and I\’m grateful to have been part of that journey. In this time, I\’ve grown in my domain, helped build our tech team from the ground up, and collaborated closely with leadership on recruitment strategies. What sets SixSense apart is the culture of transparency, open communication, and a shared sense of ownership.People stay here because they grow here. If you’re looking for a workplace that values its people and offers real opportunities to make an impact—this is it.”',
  },
];

const VoicesSlider = () => {
  return (
    <Slider showArrows={false} showDots autoPlay autoPlayInterval={15000} infinite>
      {testimonials.map((testimonial) => (
        <div className="max-w-6xl mx-auto p-6 h-full flex" key={testimonial.name}>
          <div className="bg-white rounded-2xl shadow-lg border border-gray-200 p-8">
            <div className="flex flex-col md:flex-row gap-8">
              {/* Image Section */}
              <div className="flex-shrink-0">
                <div className="w-57 h-67 rounded-lg overflow-hidden">
                  <img
                    src={testimonial.image}
                    alt={testimonial.name}
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>

              {/* Content Section */}
              <div className="flex-1">
                {/* Name and Title */}
                <div className="mb-3">
                  <h3 className="text-2xl font-medium text-[#212A31]">{testimonial.name}</h3>
                  <p className="text-[#486075] font-normal text-base">{testimonial.title}</p>
                </div>

                {/* Testimonial Quote */}
                <div className="text-[#212A31] leading-relaxed text-[1rem] font-normal">
                  <p>{testimonial.quote}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </Slider>
  );
};

export default VoicesSlider;
